// ###### IMPORTS GENERAL
// Basic imports
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Qapp imports
import { AuthProvider } from './connections/AuthContext';
import { DeviceProvider } from './services/DeviceContext';
import { OfflineStatusProvider } from './services/OfflineStatusContext';
import ConflictHandler from './shared_items/ConflictHandler';
import { syncService } from './offline_items/syncService';
import PrivateRoute from './connections/PrivateRoute';
import ModuleRoute from './connections/ModuleRoute';
import routes_web from "./connections/routes_web";

// Pages
import IndexLoad from './views/pages/indexload';
import Welcome from './views/pages/welcome';
import NotFound from './views/pages/notfound';
import Register from './views/pages/register';

// Accounts
import Login from './views/accounts/login';
import Initial from './views/accounts/initial';
import AccountsMain from './views/accounts/accounts_main';
import UserSettingsMain from './views/accounts/usersettings_main';
import GeneralSettingsMain from './views/accounts/generalsettings_main';

// Functional Apps
import CoreMain from './views/core/core_main';
import HealthMain from './views/health/health_main';
import TravelMain from './views/travel/travel_main';
import FinanceMain from './views/finance/finance_main';
import { FinanceProfileProvider } from './views/finance/moduleServices/finance_profilecontext';
import PlannerMain from './views/planner/planner_main';
import NotepadMain from './views/notepad/notepad_main';
import IdentityMain from './views/identity/identity_main';


// ###### APP COMPONENT - ROUTES NAVIGATION
function App() {
  // Initialize sync service
  React.useEffect(() => {
    syncService.initialize();
  }, []);

  return (
    <Router basename="/">
      <AuthProvider>
        <DeviceProvider>
          <OfflineStatusProvider>
            {/* Global toast container */}
            <Toaster position="top-right" reverseOrder={false} toastOptions={{ closeButton: true }} />
            
            {/* Conflict handler */}
            <ConflictHandler />

          <Routes>
          {/* Public routes */}
          <Route path={routes_web.home} element={<IndexLoad />} />
          <Route path={routes_web.pages_home} element={<Welcome />} />
          <Route path={routes_web.pages_register} element={<Register />} />
          <Route path={routes_web.accounts_login} element={<Login />} />
          
          {/* Protected routes */}
          <Route element={<PrivateRoute />}>

            {/* Account routes (does not need module access) */}
            <Route path={routes_web.accounts_initial} element={<Initial />} />
            <Route path={routes_web.accounts_home} element={<AccountsMain />} />
            <Route path={routes_web.accounts_main} element={<AccountsMain />} />
            <Route path={routes_web.accounts_usersettings} element={<UserSettingsMain />} />
            <Route path={routes_web.accounts_generalsettings} element={<GeneralSettingsMain />} />

            {/* Module protected routes */}
            <Route element={<ModuleRoute moduleName="core" />}>
              <Route path={routes_web.core_main} element={<CoreMain />} />
            </Route>

            <Route element={<ModuleRoute moduleName="health" />}>
              <Route path={routes_web.health_main} element={<HealthMain />} />
            </Route>

            <Route element={<ModuleRoute moduleName="travel" />}>
              <Route path={routes_web.travel_main} element={<TravelMain />} />
            </Route>

            <Route element={<ModuleRoute moduleName="finance" />}>
              <Route path={routes_web.finance_main} element={
                <FinanceProfileProvider>
                  <FinanceMain />
                </FinanceProfileProvider>
              } />
            </Route>

            <Route element={<ModuleRoute moduleName="planner" />}>
              <Route path={routes_web.planner_main} element={<PlannerMain />} />
            </Route>

            <Route element={<ModuleRoute moduleName="notepad" />}>
              <Route path={routes_web.notepad_main} element={<NotepadMain />} />
            </Route>

            <Route element={<ModuleRoute moduleName="identity" />}>
              <Route path={routes_web.identity_main} element={<IdentityMain />} />
            </Route>

          </Route>

          {/* 404 route */}
          <Route path="*" element={<NotFound />} />
          </Routes>
          </OfflineStatusProvider>
        </DeviceProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
